module.exports = __webpack_public_path__ + "img/bg.98949347.svg";